import React from "react";

import { GATEWAY_REGISTRY, isVendorSupported } from "./index";

import NoGatewayAvailable from "./NoGatewayAvailable";
import UnsupportedGateway from "./UnsupportedGateway";
import PlaceholderCheckout from "./PlaceholderCheckout";

const PaymentSection = ({ payload = {} }) => {
  const {
    gateways = [],
    selectedGatewayId,
    setSelectedGatewayId,
    freeTrialNoCard = false,
  } = payload;

  // ============================================================
  // CHECK AVAILABLE GATEWAYS
  // ============================================================

  const hasGateways = Array.isArray(gateways) && gateways.length > 0;

  if (!hasGateways) {
    return <NoGatewayAvailable />;
  }

  // ============================================================
  // SELECTED GATEWAY
  // ============================================================

  const selectedGateway =
    gateways.find((gateway) => gateway?._id === selectedGatewayId) ||
    gateways[0] ||
    null;

  if (!selectedGateway) {
    return <NoGatewayAvailable />;
  }

  // ============================================================
  // GATEWAY VENDOR
  // ============================================================

  const vendor = String(selectedGateway?.vendor || "").toLowerCase();

  const supported = isVendorSupported(vendor);

  const GatewayComponent = GATEWAY_REGISTRY[vendor] || null;

  // ============================================================
  // GATEWAY PAYLOAD
  // ============================================================

  const gatewayPayload = {
    ...payload,
    selectedGateway,
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <>
      {/* ====================================================== */}
      {/* PAYMENT METHOD TITLE */}
      {/* ====================================================== */}

      {!freeTrialNoCard && (
        <div className='checkout-section-title'>
          <span className='checkout-section-title-dot' />
          Payment Method
        </div>
      )}

      {/* ====================================================== */}
      {/* GATEWAY SELECTOR */}
      {/* ====================================================== */}

      {!freeTrialNoCard && (
        <div className='mb-3 d-flex gap-2 flex-wrap'>
          {gateways.map((gateway) => {
            const gatewayVendor = String(gateway?.vendor || "").toLowerCase();

            const isSupported = isVendorSupported(gatewayVendor);

            const isActive = gateway?._id === selectedGateway?._id;

            return (
              <button
                key={gateway._id}
                type='button'
                className={`btn piranha-gateway-btn ${
                  isActive ? "active" : ""
                }`}
                onClick={() => {
                  setSelectedGatewayId?.(gateway._id);
                }}
                title={isSupported ? "" : "Unsupported payment gateway"}
              >
                {gateway.label || "Payment gateway"}
              </button>
            );
          })}
        </div>
      )}

      {/* ====================================================== */}
      {/* UNSUPPORTED GATEWAY */}
      {/* ====================================================== */}

      {!supported && <UnsupportedGateway selectedGateway={selectedGateway} />}

      {/* ====================================================== */}
      {/* MISSING GATEWAY COMPONENT */}
      {/* ====================================================== */}

      {supported && !GatewayComponent && <PlaceholderCheckout />}

      {/* ====================================================== */}
      {/* SUPPORTED GATEWAY */}
      {/* ====================================================== */}

      {supported && GatewayComponent && (
        <GatewayComponent payload={gatewayPayload} />
      )}
    </>
  );
};

export default PaymentSection;
